import * as React from 'react';
import {Button,Page, ButtonsSegmented} from 'framework7-react';
import {MapDisplay} from '../MapDisplay';

/// Page container for the MapDisplay shown on the Explore tab.
export class MapPage extends React.Component {

    render () {
        var buttons;
        if (this.props.tour != null) {
            buttons = (
                <div >
                    <Button onClick={this.props.cancelTour} className="active" id="tour-x">X</Button>
                    <Button onClick={this.props.openTour} className="active" id="active-tour">{this.props.tour.name}</Button>
                </div>
            );
        }

        return (
            <Page class="map-page">
                {buttons}
                <MapDisplay buildings={this.props.buildings} config={this.props.config} showNumbers={this.props.tour != null}/>
            </Page>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/pages/Map.jsx